import { FC } from 'react'
import {
    SectionHeader,
    SectionHeaderContent,
    SectionTitle,
} from '@/ui/routes/mdr/routes/overview/overview.styles'
import { MdrSectionHeaderProps } from './MdrSectionHeader.types'

const MdrSectionHeader: FC<MdrSectionHeaderProps> = ({ title }) => {
    return (
        <SectionHeader>
            <SectionHeaderContent>
                <SectionTitle variant="m-semibold" component="h2">
                    {title}
                </SectionTitle>
            </SectionHeaderContent>
        </SectionHeader>
    )
}

export default MdrSectionHeader
